/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_CartInputs */

const en_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const ar_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#سلة`)
};

const bn_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const de_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const es_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const fr_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const pt_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const zh_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const tr_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const ru_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

const pl_svtag_cart = /** @type {(inputs: Svtag_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CART`)
};

/**
* | output |
* | --- |
* | "#CART" |
*
* @param {Svtag_CartInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_cart = /** @type {((inputs?: Svtag_CartInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_CartInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_cart(inputs)
	if (locale === "bn") return bn_svtag_cart(inputs)
	if (locale === "de") return de_svtag_cart(inputs)
	if (locale === "es") return es_svtag_cart(inputs)
	if (locale === "fr") return fr_svtag_cart(inputs)
	if (locale === "pt") return pt_svtag_cart(inputs)
	if (locale === "zh") return zh_svtag_cart(inputs)
	if (locale === "tr") return tr_svtag_cart(inputs)
	if (locale === "ru") return ru_svtag_cart(inputs)
	if (locale === "pl") return pl_svtag_cart(inputs)
	return en_svtag_cart(inputs)
});